<app-doc-rpt-dash selfDoctor='1'></app-doc-rpt-dash>
